<template>
	<div class="proposal-table px-3">
		<b-table-simple responsive bordered class="table-sm" v-loading="is_loading_table">
			<b-thead>
				<b-tr>
					<b-th class="align-middle text-center" v-if="is_editable"></b-th>
					<b-th class="align-middle text-center">No.</b-th>
					<b-th class="align-middle text-center" style="min-width: 120px;">Date/R&R</b-th>
					<b-th class="align-middle text-center" style="min-width: 130px;">Cap.</b-th>
					<b-th class="align-middle text-center" style="min-width: 180px;">Bank Name</b-th>
					<b-th class="align-middle text-center" style="min-width: 130px;">Facility</b-th>
					<b-th class="align-middle text-center" style="min-width: 130px;">Sts</b-th>
					<b-th class="align-middle text-center" style="min-width: 130px;">Outstanding</b-th>
					<b-th class="align-middle text-center" style="min-width: 130px;">Invinity<br> Cr. Settlement.</b-th>
					<b-th class="align-middle text-center" style="min-width: 130px;">Other<br> Solutions.</b-th>
				</b-tr>
			</b-thead>
			<b-tbody>
				<b-tr v-for="(item, index) in tableData" :key="index" class="text-center">
					<b-td class="align-middle" v-if="is_editable">
						<el-button type="danger" size="mini" @click="removeHandler(index)" icon="fa fa-times" circle></el-button>
					</b-td>
					<b-td class="align-middle text-center">{{ index + 1 }}</b-td>
					<b-td class="align-middle input-cell">
						<el-date-picker
							v-model="item.pcom_approved_date"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							type="date"
							placeholder="Date/R&R"
							prefix-icon="none"
							clear-icon="none"
							size="mini"
						>
						</el-date-picker>		
					</b-td>
					<b-td class="align-middle input-cell">
						<el-select v-model="item.pcom_capacity" placeholder="Select" :disabled="!is_editable" size="mini">
							<el-option v-for="cap in COMMITMENT_CAPACITIES" :key="cap" :label="cap"
								:value="cap">
							</el-option>
						</el-select>
					</b-td>
					<b-td class="align-middle input-cell">
						<el-select v-model="item.pcom_bank_id" placeholder="Select" :disabled="!is_editable" size="mini">
							<el-option v-for="bank in banks" :key="bank.bank_id" :label="bank.name" :value="bank.bank_id">
							</el-option>
						</el-select>
					</b-td>
					<b-td class="align-middle input-cell">
						<el-select v-model="item.pcom_loan_statue" placeholder="Select" :disabled="!is_editable" size="mini">
							<el-option v-for="facility in COMMITMENT_FACILITIES" :key="facility.value" :label="facility.label"
								:value="facility.value">
							</el-option>
						</el-select>
					</b-td>
					<b-td class="align-middle input-cell">
						<el-select v-model="item.pcom_sts" placeholder="Select" :disabled="!is_editable" size="mini">
							<el-option v-for="sts in COMMITMENT_STATUSES" :key="sts" :label="sts"
								:value="sts">
							</el-option>
						</el-select>
					</b-td>
					<b-td class="align-middle input-cell">
						<b-form-input type="text" v-model="item.pcom_current_outstanding" @keydown="_gHlp.checkNonNumericInput" size="mini"
							:disabled="!is_editable"></b-form-input>
					</b-td>
					<b-td class="align-middle input-cell">
						<b-form-input type="text" v-model="item.pcom_invinity_solution" @keydown="_gHlp.checkNonNumericInput" size="mini"
							:disabled="!is_editable"></b-form-input>
					</b-td>
					<b-td class="align-middle input-cell">
						<b-form-input type="text" v-model="item.pcom_other_solution" @keydown="_gHlp.checkNonNumericInput" size="mini"
							:disabled="!is_editable"></b-form-input>
					</b-td>
				</b-tr>
			</b-tbody>
			<b-tfoot>
				<b-tr class="font-weight-600">
						<b-td :colspan="is_editable ? 7 : 6" class="text-right">
							<p class="font-weight-600">Total</p>
						</b-td>
						<b-td>{{ ccrisTotalOutstanding | moneyFormatter }}</b-td>
						<b-td>{{ ccrisTotalInvinitySettlement | moneyFormatter }}</b-td>
						<b-td>{{ ccrisTotalOtherSettlement | moneyFormatter }}</b-td>
					</b-tr>
			</b-tfoot>
		</b-table-simple>
		<div class="d-flex justify-content-between" v-if="is_editable">
			<el-button size="mini" type="info" icon="fa fa-plus" @click="addAdditionalCommitment"> Add Commitment</el-button>
			<el-button size="mini" type="primary" icon="fa fa-save" @click="update" :loading="is_loading"> Update</el-button>
		</div>
	</div>
</template>
<script>
import { Select, Option, Button, DatePicker } from 'element-ui'
import { COMMITMENT_CAPACITIES, COMMITMENT_FACILITIES, COMMITMENT_STATUSES } from '@/assets/js/status.js'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import { isEqual, cloneDeep } from 'lodash'
import { mapActions, mapState } from 'pinia'
import { useInvinityStore } from '@/stores/invinityStore'
import { useLookupStore } from '@/stores/lookupStore'
import { useInitialProposalStore } from '@/stores/initialProposalStore'

export default {
	props: ['psal_id','psal_invinity_id','is_editable'],
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
		[Button.name]: Button,
		[DatePicker.name]: DatePicker,
	},
	data() {
		return {
			tableData: [],
			originalTableData: [],
			COMMITMENT_CAPACITIES: COMMITMENT_CAPACITIES,
			COMMITMENT_FACILITIES: COMMITMENT_FACILITIES,
			COMMITMENT_STATUSES: COMMITMENT_STATUSES,
			is_updated: false,
			unsavedCommitment: [],
			is_loading: false,
			is_loading_table: false,
		}
	},
	watch: {
		psal_id: {
			handler(newVal) {
				if(!_gHlp.isEmpty(newVal)){
					this.getListing(newVal)
				}
			},
			immediate: true,
		}
	},
	computed: {
		...mapState(useLookupStore, ['banks']),
		ccrisTotalLimit() {
			return this.tableData.reduce((acc, commitment) => {
				const amount = parseFloat(commitment.pcom_credit_limit);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		ccrisTotalOutstanding() {
			return this.tableData.reduce((acc, commitment) => {
				const amount = parseFloat(commitment.pcom_current_outstanding);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		ccrisTotalInstallment() {
			return this.tableData.reduce((acc, commitment) => {
				const amount = parseFloat(commitment.pcom_current_installment);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		ccrisTotalMerchantSettlement() {
			return this.tableData.reduce((acc, commitment) => {
				const amount = parseFloat(commitment.pcom_merchant_solution);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		ccrisTotalInvinitySettlement() {
			return this.tableData.reduce((acc, commitment) => {
				const amount = parseFloat(commitment.pcom_invinity_solution);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		ccrisTotalOtherSettlement() {
			return this.tableData.reduce((acc, commitment) => {
				const amount = parseFloat(commitment.pcom_other_solution);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		ccrisTotalFinalCommitment() {
			return this.tableData.reduce((acc, commitment) => {
				const amount = parseFloat(commitment.pcom_final_installment);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		}
	},
	methods: {
		...mapActions(useInvinityStore, ['syncToLms']),
		...mapActions(useInitialProposalStore, ['createProposalCommitment','updateProposalCommitment','deleteProposalCommitment','getProposalCommitmentList']),
		getListing(psal_id){
			this.is_loading_table = true
			this.tableData = []
			this.originalTableData = []
			let params = {
				search:{
					pcom_psal_id: psal_id,
					pcom_kind: 'additional'
				},
				paginate:'no_paginate'
			}
			this.getProposalCommitmentList(params).then(resp => {
				this.tableData = _gHlp.getValue(resp,'data',[]);
				this.originalTableData = cloneDeep(this.tableData);
				this.is_loading_table = false
			}).catch(e => {
				_gNotif.errorFunction(e)
				this.is_loading_table = false
			})
		},
		update() {
			var axiosCalls = []
			this.is_loading = true

			var new_commitments = this.tableData.filter(item => item.is_new)
			var current_commitments = this.tableData.filter(item => !item.is_new)

			new_commitments.forEach((item) => {
				axiosCalls.push(this.saveAdditionalCommitment(item))
			})

			current_commitments.forEach((item) => {
				const original_item = this.originalTableData.find(o_item => o_item.pcom_id === item.pcom_id)
				if (original_item && !isEqual(original_item, item)) {
					axiosCalls.push(this.updateAdditionalCommitment(item))
				}
			})

			// check for delete item
			this.originalTableData.forEach((item) => {
				const existing_item = this.tableData.find(e_item => e_item.pcom_id === item.pcom_id)
				if (!existing_item) {
					axiosCalls.push(this.deleteProposalCommitment(item.pcom_id))
				}
			})

			Promise.all(axiosCalls)
				.then(res => {
					_gNotif.notifySuccess('<b>Additional Commitments</b> - Successfully Updated.')
					this.is_loading = false
					if (axiosCalls.length > 0) {
						initialProposalEventBus.$emit('refresh-proposal-detail')
						if(!_gHlp.isEmpty(this.psal_invinity_id)){
							this.syncToLms(this.psal_id)
						}
					}
				})
				.catch(e => {
					this.is_loading = false
					_gNotif.errorFunction(e)
				})
		},
		addAdditionalCommitment() {
			this.tableData.push({
				is_new: true,
				pcom_approved_date: '',
				pcom_capacity: '',
				pcom_bank_id: '',
				pcom_loan_statue: '',
				pcom_sts: '',
				pcom_credit_limit: 0,
				pcom_current_outstanding: 0,
				pcom_current_installment: 0,
				pcom_merchant_solution: 0,
				pcom_invinity_solution: 0,
				pcom_other_solution: 0,
				pcom_final_installment: 0,
			})
		},
		saveAdditionalCommitment(item) {
			const bank = this.banks.find((bank) => bank.bank_id === item.pcom_bank_id)
			let data = {
				...item,
				pcom_psal_id: this.psal_id,
				"pcom_bank_name": bank ? bank.name : null,
				"pcom_bank_code": bank ? bank.code : null,
			}
			return this.createProposalCommitment(data)
		},
		updateAdditionalCommitment(item) {
			const bank = this.banks.find((bank) => bank.bank_id === item.pcom_bank_id)
			let data = {
				...item,
				"pcom_bank_name": bank ? bank.name : null,
				"pcom_bank_code": bank ? bank.code : null,
			}
			return this.updateProposalCommitment(data,item.pcom_id)
		},
		removeHandler(index) {
			this.tableData.splice(index, 1)
		}
	}
}
</script>